(function () {
  if (window.__tokboltProtectionStableV5) return;
  window.__tokboltProtectionStableV5 = true;

  var PROTECTION_VARIANT_ID = 52276649230619;
  var busy = false;
  var priceSyncScheduled = false;

  function isMxSpanish() {
    var path = String(window.location && window.location.pathname ? window.location.pathname : "").toLowerCase();
    var htmlLang = String(document.documentElement && document.documentElement.lang ? document.documentElement.lang : "").toLowerCase();
    var shopifyLocale = String(window.Shopify && window.Shopify.locale ? window.Shopify.locale : "").toLowerCase();

    return path.indexOf("/es-mx") === 0 || htmlLang.indexOf("es") === 0 || shopifyLocale.indexOf("es") === 0;
  }

  function updateErrorText() {
    return isMxSpanish()
      ? "No se pudo actualizar la protección de envío."
      : "Unable to update Shipping Protection.";
  }

  function addProductFirstText() {
    return isMxSpanish()
      ? "Agrega un producto antes de añadir la protección de envío."
      : "Please add a product before adding Shipping Protection.";
  }

  function route(name, fallback) {
    if (typeof routes !== "undefined" && routes && routes[name]) return routes[name];
    if (window.routes && window.routes[name]) return window.routes[name];
    return fallback;
  }

  function makeUpdateUrl() {
    var url = route("cart_update_url", "");

    if (url) {
      url = String(url);
      return url.indexOf(".js") > -1 ? url : url.replace(/\/$/, "") + ".js";
    }

    var base = String(route("cart_url", "/cart")).split("?")[0];
    base = base.replace(/\/$/, "").replace(/\.js$/, "");

    return base + "/update.js";
  }

  var CART_UPDATE_URL = makeUpdateUrl();

  function errorBox() {
    return document.getElementById("CartDrawer-CartErrors");
  }

  function clearError() {
    var box = errorBox();
    if (box) box.textContent = "";
  }

  function showError(message) {
    var box = errorBox();
    if (box) box.textContent = message || updateErrorText();
    console.error("[Tokbolt Shipping Protection]", message);
  }

  function setLoading(button, loading) {
    if (!button) return;

    button.classList.toggle("is-loading", !!loading);
    button.setAttribute("aria-busy", loading ? "true" : "false");

    if (loading) {
      button.setAttribute("disabled", "disabled");
    } else {
      button.removeAttribute("disabled");
    }
  }

  function setCartControlsLocked(locked) {
    document
      .querySelectorAll(
        "#CartDrawer .tok-cart-quantity .quantity__button, #CartDrawer .tok-cart-quantity .quantity__input, #CartDrawer .tok-cart-remove__btn"
      )
      .forEach(function (el) {
        if (locked) {
          el.setAttribute("disabled", "disabled");
          el.setAttribute("aria-disabled", "true");
        } else {
          el.removeAttribute("disabled");
          el.removeAttribute("aria-disabled");
        }
      });
  }

  function unlockProtectionButtons() {
    document.querySelectorAll("[data-protection-toggle]").forEach(function (button) {
      setLoading(button, false);
    });

    setCartControlsLocked(false);
    busy = false;
  }

  function visibleRealQuantity() {
    var total = 0;
    var foundInput = false;

    document.querySelectorAll("#CartDrawer .tok-cart-item .quantity__input").forEach(function (input) {
      foundInput = true;
      total += Math.max(0, parseInt(input.value, 10) || 0);
    });

    if (foundInput) return total;

    var count = document.querySelector("#CartDrawer .tok-cart-title-row .cart-drawer__cart-count");
    var match = count && count.textContent ? count.textContent.match(/\d+/) : null;

    return match ? parseInt(match[0], 10) || 0 : 0;
  }

  function isProtectionItem(item) {
    return Number(item.variant_id) === Number(PROTECTION_VARIANT_ID);
  }

  function protectionQuantity(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;

    return cart.items.reduce(function (sum, item) {
      return isProtectionItem(item) ? sum + Number(item.quantity || 0) : sum;
    }, 0);
  }

  function realQuantity(cart) {
    if (!cart || !Array.isArray(cart.items)) return visibleRealQuantity();

    return cart.items.reduce(function (sum, item) {
      return isProtectionItem(item) ? sum : sum + Number(item.quantity || 0);
    }, 0);
  }

  function activeCurrency() {
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      return window.Shopify.currency.active;
    }

    return "USD";
  }

  function formatMoney(cents) {
    var currency = activeCurrency();
    return "$" + (Number(cents || 0) / 100).toFixed(2) + " " + currency;
  }

  function protectionDisplayCents(baseUsdCents) {
    var cents = Number(baseUsdCents || 0);

    if (isMxSpanish() && activeCurrency() === "MXN") {
      var rate =
        window.Shopify && window.Shopify.currency
          ? Number(window.Shopify.currency.rate || 0)
          : 0;

      if (rate > 0) return Math.round(cents * rate);
    }

    return cents;
  }

  function syncProtectionPrice() {
    document.querySelectorAll("[data-protection-price]").forEach(function (node) {
      if (node.getAttribute("data-protection-price-convert-to-mxn") !== "true") return;

      var baseUsdCents = Number(node.getAttribute("data-protection-price-usd-cents") || 299);
      var nextText = formatMoney(protectionDisplayCents(baseUsdCents));

      if (node.textContent.trim() !== nextText) {
        node.textContent = nextText;
      }
    });
  }

  function scheduleSyncProtectionPrice() {
    if (priceSyncScheduled) return;

    priceSyncScheduled = true;
    window.requestAnimationFrame(function () {
      priceSyncScheduled = false;
      syncProtectionPrice();
    });
  }

  function watchProtectionPrice() {
    var root = document.querySelector("cart-drawer") || document.body;

    if (window.MutationObserver && root) {
      new MutationObserver(function () {
        scheduleSyncProtectionPrice();
      }).observe(root, { childList: true, subtree: true });
    }

    if (typeof subscribe === "function" && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        scheduleSyncProtectionPrice();
      });
    }
  }


  function findRowByKey(key) {
    var rows = document.querySelectorAll("#CartDrawer .tok-cart-item[data-tok-line-key]");

    for (var i = 0; i < rows.length; i++) {
      if (rows[i].getAttribute("data-tok-line-key") === key) return rows[i];
    }

    return null;
  }

  function setRowLineIndex(row, lineIndex) {
    if (!row || !lineIndex) return;

    row.id = "CartDrawer-Item-" + lineIndex;

    var remove = row.querySelector("cart-remove-button");
    if (remove) {
      remove.id = "CartDrawer-Remove-" + lineIndex;
      remove.setAttribute("data-index", String(lineIndex));
    }

    var quantityInput = row.querySelector("quantity-input");
    if (quantityInput) {
      quantityInput.setAttribute("data-index", String(lineIndex));
    }

    var input = row.querySelector(".quantity__input");
    if (input) {
      input.id = "Quantity-" + lineIndex;
      input.setAttribute("data-index", String(lineIndex));
    }

    var label = row.querySelector("label[for^='Quantity-']");
    if (label) {
      label.setAttribute("for", "Quantity-" + lineIndex);
    }

    var error = row.querySelector(".cart-item__error");
    if (error) {
      error.id = "CartDrawer-LineItemError-" + lineIndex;
    }
  }

  function syncLineIndexesFromCart(cart) {
    if (!cart || !Array.isArray(cart.items)) return;

    cart.items.forEach(function (item, index) {
      if (isProtectionItem(item)) return;

      var lineIndex = index + 1;
      var row = findRowByKey(item.key);

      if (row) setRowLineIndex(row, lineIndex);
    });
  }

  function updateLocalUI(cart, fallbackActive) {
    var active = cart ? protectionQuantity(cart) > 0 : !!fallbackActive;
    var button = document.querySelector("[data-protection-toggle]");

    syncLineIndexesFromCart(cart);

    if (button) {
      button.classList.toggle("is-active", active);
      button.setAttribute("aria-pressed", active ? "true" : "false");
      setLoading(button, false);
    }

    if (cart && typeof cart.total_price !== "undefined") {
      var subtotal = document.querySelector("#CartDrawer .tok-cart-subtotal .totals__subtotal-value");
      if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    }

    syncProtectionPrice();

    var count = document.querySelector("#CartDrawer .tok-cart-title-row .cart-drawer__cart-count");
    if (count) {
      var quantity = realQuantity(cart);
      count.textContent = isMxSpanish()
        ? quantity + " " + (quantity === 1 ? "artículo" : "artículos")
        : quantity + " items";
    }
  }

  function updateProtection(quantity) {
    var updates = {};
    updates[String(PROTECTION_VARIANT_ID)] = quantity;

    return fetch(CART_UPDATE_URL, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify({
        updates: updates
      })
    }).then(function (res) {
      return res.json().catch(function () {
        return {};
      }).then(function (data) {
        if (!res.ok || data.status) {
          throw new Error(data.description || data.message || "Cart update failed: " + res.status);
        }

        return data;
      });
    });
  }

  document.addEventListener(
    "click",
    function (event) {
      var button = event.target.closest("[data-protection-toggle]");
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (busy) return;

      var isActive =
        button.classList.contains("is-active") ||
        button.getAttribute("aria-pressed") === "true";

      var targetQuantity = isActive ? 0 : 1;

      if (targetQuantity === 1 && visibleRealQuantity() < 1) {
        showError(addProductFirstText());
        return;
      }

      busy = true;
      clearError();
      setLoading(button, true);
      setCartControlsLocked(true);

      updateProtection(targetQuantity)
        .then(function (cart) {
          updateLocalUI(cart, targetQuantity === 1);
        })
        .catch(function (err) {
          showError(isMxSpanish() ? updateErrorText() : err.message || updateErrorText());
          updateLocalUI(null, isActive);
        })
        .finally(function () {
          unlockProtectionButtons();
        });
    },
    true
  );

  document.addEventListener("DOMContentLoaded", function () {
    syncProtectionPrice();
    watchProtectionPrice();
    unlockProtectionButtons();
  });

  window.addEventListener("pageshow", function () {
    syncProtectionPrice();
    unlockProtectionButtons();
  });
})();
